/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/deletedApplicationsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a DeletedApplications. */
var DeletedApplications = /** @class */ (function () {
    /**
     * Create a DeletedApplications.
     * @param {GraphRbacManagementClientContext} client Reference to the service client.
     */
    function DeletedApplications(client) {
        this.client = client;
    }
    DeletedApplications.prototype.restore = function (objectId, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            options: options
        }, restoreOperationSpec, callback);
    };
    DeletedApplications.prototype.list = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, listOperationSpec, callback);
    };
    DeletedApplications.prototype.hardDelete = function (applicationObjectId, options, callback) {
        return this.client.sendOperationRequest({
            applicationObjectId: applicationObjectId,
            options: options
        }, hardDeleteOperationSpec, callback);
    };
    DeletedApplications.prototype.listNext = function (nextLink, options, callback) {
        return this.client.sendOperationRequest({
            nextLink: nextLink,
            options: options
        }, listNextOperationSpec, callback);
    };
    return DeletedApplications;
}());
export { DeletedApplications };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var restoreOperationSpec = {
    httpMethod: "POST",
    path: "{tenantID}/deletedApplications/{objectId}/restore",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.Application
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/deletedApplications",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.filter,
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.ApplicationListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var hardDeleteOperationSpec = {
    httpMethod: "DELETE",
    path: "{tenantID}/deletedApplications/{applicationObjectId}",
    urlParameters: [
        Parameters.applicationObjectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listNextOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/{nextLink}",
    urlParameters: [
        Parameters.nextLink,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.ApplicationListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=deletedApplications.js.map